import axios from "axios";
import registrations from "../../models/gestionTiempos/registrations";
import concepts from "../../models/gestionTiempos/concepts";
import csCosts from "../../models/gestionTiempos/csCosts";
import audit from "../../models/gestionTiempos/audit";
import inforules from "../../models/gestionTiempos/infoRules";
import { getConfig } from "@/config";
import moment from "moment";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getRegistrations(date) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/regis/${empId}&${date}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return registrations.fromJson(item);
        }),
      );
  }
  /*   getConcepts() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/conceptos/lic`, { headers }).then(({ data }) =>
      data.map((item) => {
        return concepts.fromJson(item);
      })
    );
  } */
  getConceptsNov() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let operId = parseInt(localStorage.getItem("operId"), 10);
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/conceptos/bnov/${operId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return concepts.fromJson(item);
        }),
      );
  }
  /*   getCsCost() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/cscostos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return csCosts.fromJson(item);
      })
    );
  } */
  getCsCostNov() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let operId = parseInt(localStorage.getItem("operId"), 10);
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/cscosto/bnov/${operId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return csCosts.fromJson(item);
        }),
      );
  }
  getCsCostGuidelines() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/cscostos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return csCosts.fromJson(item);
      }),
    );
  }
  getAudit() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/coments/audit`, { headers }).then(({ data }) =>
      data.map((item) => {
        return audit.fromJson(item);
      }),
    );
  }

  delete = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let operId = parseInt(localStorage.getItem("operId"), 10);
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = data.empId;
    let fecha = moment().format("YYYY-MM-DD");

    let entrada = moment.utc(data.entrada).format("YYYY-MM-DD HH:mm");

    let comentId = data.audit == undefined ? " " : "comentId=" + data.audit;
    console.log("D:", data.entrada);
    console.log("Entrada formateada:", entrada);

    return axios.delete(
      `${url}/regis/${empId}&${fecha}&${entrada}&${operId}?${comentId}`,
      {
        headers,
      },
    );
  };

  edit = (data) => {
    let empId = data.empId;
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let operId = parseInt(localStorage.getItem("operId"), 10);
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;
    let audit = localStorage.getItem("auditRegis");
    payload = {
      fecha: data.fecha,
      entrada: data.fechaEntrada,
      salida: data.fechaSalida,
      csCostoId: data.csCostoId,
      conceptoId: data.conceptoId,
      comentId: audit ? data.comentId : undefined,
      operId: operId,
    };

    if (data.observaciones) {
      payload.observaciones = data.observaciones;
    }

    return axios
      .patch(`${url}/regis/${empId}&${data.entradaOriginal}`, payload, {
        headers,
      })
      .then(() => {});
  };

  new = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let operId = parseInt(localStorage.getItem("operId"), 10);
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const audit = localStorage.getItem("auditRegis");
    let payload = {
      empId: data.empId,
      fecha: data.fecha,
      entrada: data.entrada,
      salida: data.originExit,
      csCostoId: data.csCostoId,
      conceptoId: data.conceptoId,
      comentId: audit == "true" ? data.comentId : undefined,
      operId: operId,
    };

    if (data.observaciones) {
      payload.observaciones = data.observaciones;
    }

    return axios.post(`${url}/regis`, payload, { headers });
  };

  newRule = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let operId = parseInt(localStorage.getItem("operId"), 10);
    let empId = parseInt(localStorage.getItem("empId"), 10);
    let payload = {
      operId: operId,
      empId: empId,
      fecha: data.date,
      regla: data.rule,
      conceptoId: data.concept,
      cscostoId: data.csCost,
      entrada: data.from,
      salida: data.to,
      canthoras: data.amountHours,
    };

    return axios.post(`${url}/regis/reglas`, payload, { headers });
  };

  getInfoRules() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/regis/reglas/info`, { headers }).then(({ data }) =>
      data["reglas de registraciones"].map((item) => {
        return inforules.fromJson(item);
      }),
    );
  }

  getCurrentAccount(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let conceptPart = data.conceptoId ? `?conceptoid=${data.conceptoId}` : "";
    let fullUrl = `${url}/cuentas/empleados/saldos/${data.empId}&${data.fecha}${conceptPart}`;

    return axios.get(fullUrl, { headers }).then((data) => data.data);
  }
}
export default service;
